export const STUDENT_EVALUATION = "Students";
export const COACH_EVALUATION = "Survey for Teacher";
export const PARENT_EVALUATION = "Parents";



// WEBPACK FOOTER //
// ./src/pages/director/dashboard/components/sport-table/components/survey-link/utils/constants.ts